module.exports = __webpack_public_path__ + "resources/img/img_dataquery_m_jp.fad25d8d56a6310c735028fc4f5036b9.png";